import config from 'utils/apiconfig';
import request from 'utils/request';

const {api} = config;
const {shareInfo, shareInfoId, shareInfoPublishId, shareInfoTopId} = api;

/**
 * 查询列表
 */
export async function list(params) {
  return request({url: shareInfo, method: 'get', data: params,});
}

/**
 * 查询详情
 */
export async function getDetail(paramId) {
  return request({
    url: shareInfoId, method: 'get', data: {
      id: paramId
    },
  });
}

/**
 * 查询详情
 */
export async function publish(params) {
  return request({
    url: shareInfoPublishId, method: 'put', data: params
  });
}

export async function shareInfoTop(params) {
  return request({
    url: shareInfoTopId, method: 'put', data: params
  });
}

/**
 * 编辑
 */
export async function edit(params) {
  return request({url: shareInfoId, method: 'put', data: params});
}

/**
 * 删除
 */
export async function deleteItem(params) {
  return request({url: shareInfo+ '/delete' , method: 'post', data: params});
}

/**
 * 创建
 */
export async function createItem(params) {
  return request({url: shareInfo, method: 'post', data: params,});
}
